import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ToastController, LoadingController, AlertController } from '@ionic/angular';
import { FeedbackService } from './feedback.service';
import { ApiCustomerService } from '../api-services/customer.api.service';
import { API_SETTINGS } from '../api-services/API_SETTINGS';
import { MessagesService } from './messages.service';
import { CryptoService } from './crypto.service';
import { CustomerUsageService } from './customer-usage.service';

declare var ecomSecurity: any;

@Injectable({
  providedIn: 'root'
})

export class AuthenticationService {

  public email: any = "";
  public password: any = "";
  public isLoggedIn: boolean = false;
  public loginStatus: any = 'login';
  public userData: any = {};
  public currentUser;
  public showError = false;
  public shown2fa = false;
  public superAdmin = false;
  public author = false;
  public administrator = false;
  public authenticationValid = false;

  constructor(
    public router: Router,
    private httpClient: HttpClient,
    public toastController: ToastController,
    public loadingController: LoadingController,
    public feedbackService: FeedbackService,
    public activatedRoute: ActivatedRoute,
    public customerApiService: ApiCustomerService,
    public messagesService: MessagesService,
    public alertController: AlertController,
    public cryptoService: CryptoService,
    private customerUsageService: CustomerUsageService
  ) {
    this.showError = false;
  }

  async checkLogin() {
    var loginAuth = this.cryptoService.decryptData(localStorage.getItem("login_auth"));
    if (loginAuth != null && loginAuth != undefined) {
      if (loginAuth.length > 0) {
        //this.isLoggedIn = true;
        this.authenticationValid = true;
        this.userData = JSON.parse(loginAuth);

        var email = this.cryptoService.decryptData(localStorage.getItem("login_email"));
        await this.messagesService.presentLoadingWindow("Checking account", 'checking-account');

        //setTimeout(() => {
        //this.messagesService.loadingWindow.dismiss('checking-account');
        //}, 5000);
        this.communicateApi("authentication/checkemail/" + email).subscribe((res: any) => {
          this.messagesService.loadingWindow.dismiss('checking-account');
          switch (res.toString()) {
            case "SuperAdmin":
              localStorage.setItem("login_r", this.cryptoService.encryptData("sa"));
              this.superAdmin = true;
              this.administrator = false;
              this.author = false;
              break;
            case "Author":
              localStorage.setItem("login_r", this.cryptoService.encryptData("au"));
              this.author = true;
              this.administrator = false;
              this.superAdmin = false;
              break;
            case "Administrator":
              localStorage.setItem("login_r", this.cryptoService.encryptData("ad"));
              this.administrator = true;
              this.author = false;
              this.superAdmin = false;
              break;
          }
          this.messagesService.dismissLoadingWindowById('checking-account');
        }, (err: any) => {
          if (err.error.toString() == "No User Found...") {
            this.messagesService.dismissLoadingWindowById('checking-account');
            this.logOut();
          } else {
            switch (err.error.toString()) {
              case "SuperAdmin":
                localStorage.setItem("login_r", this.cryptoService.encryptData("sa"));
                this.superAdmin = true;
                this.administrator = false;
                this.author = false;
                break;
              case "Author":
                localStorage.setItem("login_r", this.cryptoService.encryptData("au"));
                this.author = true;
                this.administrator = false;
                this.superAdmin = false;
                break;
              case "Administrator":
                localStorage.setItem("login_r", this.cryptoService.encryptData("ad"));
                this.administrator = true;
                this.author = false;
                this.superAdmin = false;
                break;
            }
            this.messagesService.dismissLoadingWindowById('checking-account');
          }
        });
      }
    }
  }

  authorise() {
    if (this.isLoggedIn == false) {
      this.router.navigateByUrl(this.getLaunchUrl());
    }
  }

  loginStatusChange(loggedIn) {
    this.authenticationValid = loggedIn;
    if (loggedIn) {
      this.customerApiService.getCustomerIdWithDomain(this.email).subscribe(id => {
        localStorage.setItem('customerId', this.cryptoService.encryptData(id.toString()));
        localStorage.setItem("login_auth", this.cryptoService.encryptData("true"));
        this.customerUsageService.getCustomerFileUsage();
        if (this.cryptoService.decryptData(localStorage.getItem("login_r")) != "sa") {
          this.check2FA();
        }
        else {
          localStorage.setItem("valid", "true");
          this.isLoggedIn = true;
          window.location.reload();
        }
        //window.location.reload();
        //this.router.navigateByUrl('/two-factor-authentication');
      });
    }
    else {
      localStorage.removeItem("login_auth");
      localStorage.removeItem("customerId");
      this.router.navigateByUrl(this.loginStatus);
    }
    // this.router.navigateByUrl(this.getLaunchUrl());
  }

  attemptLogin(username, token) {
    this.apiLogin(username, token);
  }

  attemptRegister(firstName, lastName, email, company, jobTitle) {
    if (email.indexOf('@ecomscotland.com') >= 0
      || email.indexOf('@sqa.org.uk') >= 0
      || email.indexOf('@cityofglasgowcollege.ac.uk') >= 0
      || email.indexOf("@fife.ac.uk") >= 0) {
      this.apiRegister(firstName, lastName, email, company, jobTitle);
    }
    else {
      this.presentToast("Your email address doesn't exist to an organization that has access to the Alpha. Please check back here in a few months for access to our Beta version.", 5000);
      return false;
    }
    return true;
  }

  attemptPasswordReset() {
    this.alertController.create({
      header: 'Reset your password',
      message: 'Please enter your email',
      inputs: [
        {
          name: 'email',
          type: 'email',
          placeholder: 'Email'
        }
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {

          }
        }, {
          text: 'Reset Password',
          handler: (data) => {
            var email = data.email;
            this.communicateApi("authentication/passwordreset/" + email).subscribe((res: any) => {
              if (res.toString() == "Success") {
                this.presentToast("Password reset request sent. You should receive an email shortly.", 5000);
              } else {
                this.presentToast("Invalid email address. Please try again.", 5000);
              }
            }, (error: any) => {
              if (error.error.text == "Success")
                this.presentToast("Password reset request sent. You should receive an email shortly.", 5000);
              else
                this.presentToast("Invalid email address. Please try again.", 5000);
            });
          }
        }
      ]
    }).then(a => {
      a.present();
    });
  }

  logOut() {
    localStorage.clear();
    this.isLoggedIn = false;
    this.launchLogin();
  }

  apiLogin(email, token) {
    this.showError = false;
    this.communicateApi("authentication/login/" + email + "/" + encodeURIComponent(token) + "").subscribe((res: any) => {
      //console.log(res);
      if (res != null) {
        this.email = res.email;
        // Record the login email;
        localStorage.setItem("login_email", this.cryptoService.encryptData(res.email));
        switch (res.role.toString()) {
          case "SuperAdmin":
            localStorage.setItem("login_r", this.cryptoService.encryptData("sa"));
            this.superAdmin = true;
            break;
          case "Author":
            localStorage.setItem("login_r", this.cryptoService.encryptData("au"));
            this.author = true;
            break;
          case "Administrator":
            localStorage.setItem("login_r", this.cryptoService.encryptData("ad"));
            this.administrator = true;
            break;
        }
        this.loginStatusChange(true);
        this.presentToast("Login successful.", 2000);
      } else {
        this.showError = true;
        this.password = "";
      }
    }, (er: any) => {
      var error = er.error.text;
      if (error.role) {
        if (error.role.toString() == "SuperAdmin" || error.role.toString() == "Administrator" || error.role.toString() == "Author") {
          this.email = error.email;
          localStorage.setItem("login_email", this.cryptoService.encryptData(error.email));
          switch (error.role.toString()) {
            case "SuperAdmin":
              localStorage.setItem("login_r", this.cryptoService.encryptData("sa"));
              this.superAdmin = true;
              break;
            case "Author":
              localStorage.setItem("login_r", this.cryptoService.encryptData("au"));
              this.author = true;
              break;
            case "Administrator":
              localStorage.setItem("login_r", this.cryptoService.encryptData("ad"));
              this.administrator = true;
              break;
          }
          this.loginStatusChange(true);
          this.presentToast("Login successful.", 2000);
        } else {
          this.showError = true;
          this.password = "";
        }
      } else {
        this.showError = true;
        this.password = "";
      }
    });
  }

  check2FA() {
    // Ignore 2FA for super admins;
    if (!this.shown2fa && !this.superAdmin) {
      if (localStorage.getItem("login_email") != null) {
        if (localStorage.getItem("USR") != this.cryptoService.decryptData(localStorage.getItem("login_email"))) {
          this.shown2fa = true;
          ecomSecurity.init(this.cryptoService.decryptData(localStorage.getItem("login_email")), this.cryptoService.decryptData(localStorage.getItem("login_email")));
        }
      }
    }
  }

  redirectTo2FA() {
    if (localStorage.getItem("login_email") != null) {
      if (this.cryptoService.decryptData(localStorage.getItem('USR')) == null || localStorage.getItem("USR") != this.cryptoService.decryptData(localStorage.getItem("login_email"))) {
        return true;
      }
      else {
        return false;
      }
    }
    else {
      return false;
    }
  }

  async apiRegister(firstName, lastName, emailAddress, companyName, jobTitle) {
    await this.messagesService.presentLoadingWindow("Registering the account");
    this.communicateApi("authentication/register/" + firstName + "/" + lastName + "/" + emailAddress + "/" + companyName + "/" + jobTitle).subscribe((res: any) => {
      this.presentToastWithOptions("Registration successful", "please note your token for logging in for future reference - the token will have been emailed to your email address.");
      //  this.feedbackService.recordFeedback(firstName + " " + lastName, emailAddress, companyName, "Registration", jobTitle);
      try {
        this.messagesService.loadingWindow.dismiss();
        this.presentToastWithOptions("Registration successful", "please note your token for logging in for future reference - the token will have been emailed to your email address.");
        //    this.feedbackService.recordFeedback(firstName + " " + lastName, emailAddress, companyName, "Registration", jobTitle);
      } catch {
        this.messagesService.loadingWindow.dismiss();
        this.presentToast("Registration unsuccessful.", 2000);
      }
    }, (error: any) => {
      if (error.error.text.toString().length == 6) {
        this.messagesService.loadingWindow.dismiss();
        this.presentToastWithOptions("Registration successful", "please note your token for logging in for future reference - the token will have been emailed to your email address.");
        //    this.feedbackService.recordFeedback(firstName + " " + lastName, emailAddress, companyName, "Registration", jobTitle);
      } else {
        this.messagesService.loadingWindow.dismiss();
        this.presentToast("Registration unsuccessful.", 2000);
      }
    });
  }

  communicateApi(urlParams): Observable<any> {
    var url = API_SETTINGS.API_URL + urlParams;
    return this.httpClient.get<any>(url);
  }

  assignLogin(username) {

  }

  async presentToast(msg, duration) {
    const toast = await this.toastController.create({
      message: msg,
      duration: duration
    });
    toast.present();
  }

  async presentToastWithOptions(header, msg) {
    const toast = await this.toastController.create({
      header: header,
      message: msg,
      position: 'top',
      duration: 3000,
      buttons: [
        {
          side: 'start',
          icon: 'checkmark-circle',
          text: 'Done',
          handler: () => {
            // this.loginStatusChange(true);
          }
        }
      ]
    });

    toast.onDidDismiss().then(() => {
      this.launchLogin();
    }),

      toast.present();
  }

  launchRegister() {
    this.loginStatus = "registration";
    this.loginStatusChange(false);
  }

  launchLogin() {
    this.loginStatus = "login";
    this.loginStatusChange(false);
  }

  getLaunchUrl() {
    if (this.isLoggedIn) {
      return "home";
    } else {
      return this.loginStatus;
    }
  }
}
